import React from 'react';

export const Survey = () => {
  return (
    <div className="bg-gray-200 p-4">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScGXGsO63EqWtn3do0-SDKC6-g4snlH41OQQA2NORLHTNjmyw/viewform?embedded=true" width="640" height="1887" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </div>
  );
};
